<!-- @format -->

<template>
    <div class="gst-picture-base">
        <BaseImage
            :src="src"
            :alt="alt" />
    </div>
</template>

<script>
export default {
    name: 'PictureBase',

    props: {
        src: {
            type: String,
            default: '',
        },
        alt: {
            type: String,
            default: '',
        },
    },
};
</script>
